import GEO_TYPES from '../../../../serp/constants/geo-types';

angular.module('cian.filterTag')
  .directive('filterTag', () => ({
    scope: {},
    bindToController: {
      tag: '='
    },
    controllerAs: 'tagCtrl',
    controller: [
      'FilterService',
      function (FilterService) {
        const ctrl = this;

        ctrl.removeTag = () => FilterService.remove(ctrl.tag);

        ctrl.isMetroWithColor =
          ctrl.tag.value.type === GEO_TYPES.UNDERGROUND && ctrl.tag.value.color;
      }],
    template: require('../../templates/filter-tag.html')
  }));



// WEBPACK FOOTER //
// ./src/components/filter-tag/src/scripts/cian.filter-tag.dir.js